webpackJsonp([226020273838829],{

/***/ "./node_modules/numeral/numeral.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.6',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0',
	            scalePercentBy100: true
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat,
	            scalePercentBy100: defaults.scalePercentBy100
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                leadingCount = 0,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, 0, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (int.length < leadingCount) {
	                for (var i = leadingCount - int.length; i > 0; i--) {
	                    int = '0' + int;
	                }
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        numeral.register('format', 'bps', {
	            regexps: {
	                format: /(BPS)/,
	                unformat: /(BPS)/
	            },
	            format: function(value, format, roundingFunction) {
	                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
	                    output;
	
	                value = value * 10000;
	
	                // check for space before BPS
	                format = format.replace(/\s?BPS/, '');
	
	                output = numeral._.numberToFormat(value, format, roundingFunction);
	
	                if (numeral._.includes(output, ')')) {
	                    output = output.split('');
	
	                    output.splice(-1, 0, space + 'BPS');
	
	                    output = output.join('');
	                } else {
	                    output = output + space + 'BPS';
	                }
	
	                return output;
	            },
	            unformat: function(string) {
	                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
	            }
	        });
	})();
	
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
	            return decimal.suffixes.indexOf(item) < 0;
	        }));
	        var unformatRegex = allSuffixes.join('|');
	        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
	        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp(unformatRegex)
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            if (numeral.options.scalePercentBy100) {
	                value = value * 100;
	            }
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            var number = numeral._.stringToNumber(string);
	            if (numeral.options.scalePercentBy100) {
	                return number * 0.01;
	            }
	            return number;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ }),

/***/ "./src/assets/logosOne.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logosOne.6970a6ac.png";

/***/ }),

/***/ "./src/assets/logosTwo.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logosTwo.82754405.png";

/***/ }),

/***/ "./src/assets/svgs/PricingBackground.svg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/PricingBackground.505bba09.svg";

/***/ }),

/***/ "./src/assets/svgs/SectionCalloutBackground.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/components/LogoMarquee.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marqueeAnim = (0, _styledComponents.keyframes)(["0%{transform:translateX(0);}100%{transform:translateX(-100%);}"]);
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: "LogoMarquee__Wrapper"
	})(["overflow:hidden;"]);
	
	var Marquee = _styledComponents2.default.div.withConfig({
	  displayName: "LogoMarquee__Marquee"
	})(["white-space:nowrap;position:relative;font-size:0;img{position:relative;animation:", " ", "ms infinite linear;display:inline-block;width:auto;height:70px;}"], marqueeAnim, function (props) {
	  return props.speed;
	});
	
	var LogoMarquee = function LogoMarquee(_ref) {
	  var src = _ref.src,
	      speed = _ref.speed;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      Marquee,
	      { speed: speed },
	      _react2.default.createElement("img", { alt: "logos", src: src }),
	      _react2.default.createElement("img", { alt: "logos", src: src })
	    )
	  );
	};
	
	LogoMarquee.defaultProps = {
	  speed: 40000
	};
	
	exports.default = LogoMarquee;
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-preset-react/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-preset-es2015/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-preset-stage-0/lib/index.js\",[\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/Users/robertgonzales/Sites/smallchat/website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-plugin-styled-components/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/pricing.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _numeral = __webpack_require__("./node_modules/numeral/numeral.js");
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__("./src/components/consts/colors.js");
	
	var _AddtoSlack = __webpack_require__("./src/components/AddtoSlack.js");
	
	var _AddtoSlack2 = _interopRequireDefault(_AddtoSlack);
	
	var _LogoMarquee = __webpack_require__("./src/components/LogoMarquee.js");
	
	var _LogoMarquee2 = _interopRequireDefault(_LogoMarquee);
	
	var _SectionBackground = __webpack_require__("./src/components/SectionBackground.js");
	
	var _SectionBackground2 = _interopRequireDefault(_SectionBackground);
	
	var _PricingBackground = __webpack_require__("./src/assets/svgs/PricingBackground.svg");
	
	var _PricingBackground2 = _interopRequireDefault(_PricingBackground);
	
	var _logosOne = __webpack_require__("./src/assets/logosOne.png");
	
	var _logosOne2 = _interopRequireDefault(_logosOne);
	
	var _logosTwo = __webpack_require__("./src/assets/logosTwo.png");
	
	var _logosTwo2 = _interopRequireDefault(_logosTwo);
	
	var _withScreensize = __webpack_require__("./src/components/withScreensize.js");
	
	var _withScreensize2 = _interopRequireDefault(_withScreensize);
	
	var _SectionCallout = __webpack_require__("./src/components/SectionCallout.js");
	
	var _SectionCallout2 = _interopRequireDefault(_SectionCallout);
	
	var _SectionCalloutBackground = __webpack_require__("./src/assets/svgs/SectionCalloutBackground.svg");
	
	var _SectionCalloutBackground2 = _interopRequireDefault(_SectionCalloutBackground);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PricingContainer = _styledComponents2.default.div.withConfig({
	  displayName: "pricing__PricingContainer"
	})(["overflow:hidden;"]);
	
	var PricingHeader = _styledComponents2.default.header.withConfig({
	  displayName: "pricing__PricingHeader"
	})(["position:relative;z-index:10;text-align:center;padding:50px 50px 0;h1{display:inline-block;}"]);
	
	var toggleHover = (0, _styledComponents.css)(["&:after{content:\"\";position:absolute;top:100%;left:10%;display:block;width:80%;height:2px;background-color:", ";}"], _colors.SMALLCHAT_PURPLE);
	
	var PricingToggle = _styledComponents2.default.button.withConfig({
	  displayName: "pricing__PricingToggle"
	})(["position:relative;outline:none;border:none;background:none;padding:0;margin:30px 20px 20px;font-size:16px;line-height:24px;font-weight:900;font-family:\"Rubik\";color:", ";cursor:pointer;", ";&:hover{color:", ";", ";}"], function (props) {
	  return props.selected ? _colors.PRIMARY_TEXT : _colors.TERTIARY_TEXT;
	}, function (props) {
	  return props.selected && toggleHover;
	}, _colors.PRIMARY_TEXT, toggleHover);
	
	var PricingWrapper = _styledComponents2.default.div.withConfig({
	  displayName: "pricing__PricingWrapper"
	})(["z-index:2;position:relative;max-width:1200px;margin:0 auto;padding:0 50px;width:100%;@media (max-width:480px){padding:0 20px;}"]);
	
	var PricingPlans = _styledComponents2.default.div.withConfig({
	  displayName: "pricing__PricingPlans"
	})(["z-index:2;position:relative;display:flex;padding:50px 0;margin-bottom:100px;background-color:white;border-radius:50px;box-shadow:0 0 20px 0 ", ";@media (max-width:768px){flex-direction:column;padding:0 50px;}@media (max-width:480px){flex-direction:column;padding:0 20px;}"], _colors.SMALLCHAT_SHADOW);
	
	var PlanContainer = _styledComponents2.default.div.withConfig({
	  displayName: "pricing__PlanContainer"
	})(["position:relative;display:flex;align-items:center;flex-direction:column;width:100%;padding:0 20px;text-align:center;@media (max-width:768px){padding:50px 0;}& + &:before{content:\"\";position:absolute;top:0;left:0;display:block;width:1px;height:100%;background-color:", ";@media (max-width:768px){height:1px;width:100%;}}"], _colors.TERTIARY_TEXT);
	
	var PlanPrice = _styledComponents2.default.div.withConfig({
	  displayName: "pricing__PlanPrice"
	})(["margin:10px 0;display:flex;text-align:center;align-items:center;justify-content:center;font-weight:900;font-family:\"Rubik\";h1{margin:0 5px;font-size:80px;line-height:70px;@media (max-width:480px){font-size:60px;}}span{align-self:flex-start;}"]);
	
	var PlanLabel = _styledComponents2.default.h4.withConfig({
	  displayName: "pricing__PlanLabel"
	})(["font-family:\"Lato\";font-weight:500;font-size:21px;color:", ";"], _colors.SECONDARY_TEXT);
	
	var PlanFeatures = _styledComponents2.default.ul.withConfig({
	  displayName: "pricing__PlanFeatures"
	})(["margin:20px 0;padding:0;min-height:100px;list-style-type:none;li{font-size:15px;line-height:24px;", ";}"], function (props) {
	  return props.selected && (0, _styledComponents.css)(["color:#9192c5;font-weight:600;"]);
	});
	
	var PlanPrompt = (0, _styledComponents2.default)(_AddtoSlack2.default).withConfig({
	  displayName: "pricing__PlanPrompt"
	})(["margin:15px 0;"]);
	
	var PricingValidation = _styledComponents2.default.div.withConfig({
	  displayName: "pricing__PricingValidation"
	})(["z-index:2;position:relative;text-align:center;margin:50px 0 100px;h2{margin-bottom:30px;}"]);
	
	var PricingPlan = function PricingPlan(_ref) {
	  var index = _ref.index,
	      interval = _ref.interval,
	      activeIndex = _ref.activeIndex,
	      onSelect = _ref.onSelect,
	      planPrice = _ref.planPrice,
	      planLabel = _ref.planLabel,
	      featureList = _ref.featureList;
	
	  var priceForInterval = planPrice * (interval === 12 ? 0.8 : 1);
	
	  var _numeral$format$split = (0, _numeral2.default)(priceForInterval).format("0.00").split("."),
	      dollars = _numeral$format$split[0],
	      cents = _numeral$format$split[1];
	
	  return _react2.default.createElement(
	    PlanContainer,
	    { onMouseOver: function onMouseOver(e) {
	        return onSelect(index);
	      } },
	    _react2.default.createElement(
	      PlanPrice,
	      null,
	      "$",
	      _react2.default.createElement(
	        "h1",
	        null,
	        dollars
	      ),
	      _react2.default.createElement(
	        "span",
	        null,
	        cents
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      {
	        style: {
	          position: "relative",
	          top: "-5px",
	          fontSize: "13px",
	          color: "#B3B3BF"
	        }
	      },
	      "per month"
	    ),
	    _react2.default.createElement(
	      PlanLabel,
	      null,
	      planLabel
	    ),
	    _react2.default.createElement(
	      PlanFeatures,
	      { selected: activeIndex >= index },
	      featureList.map(function (feature, index) {
	        return _react2.default.createElement(
	          "li",
	          { key: index },
	          "- ",
	          feature
	        );
	      })
	    ),
	    _react2.default.createElement(PlanPrompt, null)
	  );
	};
	
	var Pricing = function (_Component) {
	  _inherits(Pricing, _Component);
	
	  function Pricing() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Pricing);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      interval: 1,
	      activeIndex: null
	    }, _this.selectPlan = function (index) {
	      if (index !== _this.state.activeIndex) {
	        _this.setState({ activeIndex: index });
	      }
	    }, _this.setInterval = function (interval) {
	      _this.setState({ interval: interval });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Pricing.prototype.render = function render() {
	    var _this2 = this;
	
	    var isMobile = this.props.screensize === "phone";
	    var isTablet = this.props.screensize === "tablet";
	    return _react2.default.createElement(
	      PricingContainer,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: "Smallchat Pricing" }),
	      _react2.default.createElement(
	        PricingHeader,
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Start using Smallchat for free."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "And then keep using it for free if you'd like."
	        ),
	        _react2.default.createElement(
	          PricingToggle,
	          {
	            selected: this.state.interval === 12,
	            onClick: function onClick(e) {
	              return _this2.setInterval(12);
	            }
	          },
	          "Annually"
	        ),
	        _react2.default.createElement(
	          PricingToggle,
	          {
	            selected: this.state.interval === 1,
	            onClick: function onClick(e) {
	              return _this2.setInterval(1);
	            }
	          },
	          "Monthly"
	        )
	      ),
	      _react2.default.createElement(
	        PricingWrapper,
	        null,
	        _react2.default.createElement(_SectionBackground2.default, {
	          background: _PricingBackground2.default,
	          backgroundWidth: "140%",
	          backgroundOrigin: "top",
	          backgroundHeight: "130%",
	          backgroundScale: isMobile ? 5 : isTablet ? 2 : 1.2,
	          backgroundTop: isMobile || isTablet ? 0 : "-20%",
	          backgroundRight: "-40%"
	        }),
	        _react2.default.createElement(
	          PricingPlans,
	          null,
	          _react2.default.createElement(PricingPlan, _extends({}, this.state, {
	            index: 0,
	            onSelect: this.selectPlan,
	            planPrice: 0,
	            planLabel: "Personal \uD83D\uDC76",
	            featureList: ["Unlimited conversations", "Unlimited operators", "10k/mo pageviews", "Full customization of your widget"]
	          })),
	          _react2.default.createElement(PricingPlan, _extends({}, this.state, {
	            index: 1,
	            onSelect: this.selectPlan,
	            planPrice: 19.99,
	            planLabel: "Growth \uD83D\uDE0E",
	            featureList: ["All Personal tier features plus", "Custom auto messages", "Contact list with export", "Unlimited pageviews"]
	          })),
	          _react2.default.createElement(PricingPlan, _extends({}, this.state, {
	            index: 2,
	            onSelect: this.selectPlan,
	            planPrice: 39.99,
	            planLabel: "Business \uD83D\uDCBC",
	            featureList: ["All Personal + Growth tier features plus", "Multiple Slack channels + widgets", "File uploads", "Whitelabel chat widget", "Javascript API"]
	          }))
	        )
	      ),
	      _react2.default.createElement(
	        PricingValidation,
	        null,
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Trusted by over 5000 teams!"
	        ),
	        _react2.default.createElement(_LogoMarquee2.default, { src: _logosOne2.default, speed: 35000 }),
	        _react2.default.createElement(_LogoMarquee2.default, { src: _logosTwo2.default, speed: 40000 })
	      ),
	      _react2.default.createElement(_SectionCallout2.default, {
	        darkShadow: true,
	        background: _SectionCalloutBackground2.default,
	        backgroundSize: "cover",
	        backgroundPosition: "80% 80%",
	        title: "Start your conversations today."
	      })
	    );
	  };
	
	  return Pricing;
	}(_react.Component);
	
	exports.default = (0, _withScreensize2.default)(Pricing);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pricing-js-676f6ea5680c50b4e37a.js